module.exports = __webpack_public_path__ + "img/sohva-miljoo.54e5be31.webp";